export const locale = {
  lang: "fr",
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: "Tableaux de bord",
      },
      ESP: {
        COLLAPSIBLE: "Espace marchand",
      },
      Wallet: {
        SECTION: "Wallet",
        AW: {
          COLLAPSIBLE: "Alimenter mon Wallet",
          Carte: "Par Carte de paiement",
          Espece: "Par versement/virement",
          RV: "Via un revendeur",
        },
        TA: {
          COLLAPSIBLE: "Transférer de l’argent",
          ws: "Wallet SPW",
          cb: "Compte bancaire",
        },
        MW: {
          COLLAPSIBLE: "Mes wallets",
        },
      },
      SERVICE: {
        SECTION: "Services",
        RT: {
          COLLAPSIBLE: "Recharge Téléphonique",
          TD: "Transfert direct",
          CR: "Carte de recharge",
        },
        DS: {
          COLLAPSIBLE: "Divertissement",
        },
        PM: {
          COLLAPSIBLE: "Paiement Marchand",
        },
        GCB: {
          COLLAPSIBLE: "Gestion des cartes",
        },
      },
      AUTRE: {
        SECTION: "****",
        FP: {
          COLLAPSIBLE: "Programme de fidélité",
        },
        MT: {
          COLLAPSIBLE: "Transactions",
        },
        MC: {
          COLLAPSIBLE: "Consommation",
        },
        dashm: {
          COLLAPSIBLE: "Tableau de bord marchand",
        },
        moncompte: {
          COLLAPSIBLE: "Mon compte",
        },
        trvr: {
          COLLAPSIBLE: "Transfert et virements",
        },
        his: {
          COLLAPSIBLE: "Historique",
        },
        conso: {
          COLLAPSIBLE: "Consommation",
        }
      },
      DOC: {
        SECTION: "Documents",
      },
      FAQ: {
        SECTION: "FAQ et Contact",
      },
    },
  },
};
